import { Fragment, useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMultiState } from "../lib/hooks";

import {
  Box,
  Flex,
  useToast,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";

import {
  useQuery,
  useMutation,
  useLazyQuery,
  useApolloClient,
} from "@apollo/client"; // Added useLazyQuery
import AuthContext from "../contexts/AuthContext";
import { useParams } from "react-router";
import GetStudentProgress from "../graphql/queries/progress"; // Add this import
import Subject from "../graphql/queries/subject";
import allprogress from "../graphql/queries/allprogress";
import studentEnroll from "../graphql/queries/studentenroll";
import updateStudentOfSubject from "../graphql/mutations/updateStudentOfSubject";
import studentofsubjectsRemoveMutation from "../graphql/mutations/removeStudentofSubject";
import GetContentQuestionConfigQuery from "../graphql/queries/question"; // Query for content's question config
// import GetStudentQuizAnswerQuery from '../graphql/queries/questionbyStudent'; // Replaced by GetScoresQuery
import GetScoresQuery from "../graphql/queries/scorequestionbyStudent"; // Query for student's processed quiz answers
import GetStudentSurveyAnswersQuery from "../graphql/queries/surveybyuserId"; // Corrected import for student's survey answers

import StudentListPanel from "../components/pages/ManageEnrollSubjectPage/StudentListPanel";
import DashboardDetail from "../components/pages/ManageEnrollSubjectPage/DashboardDetail";
import DialogCertificate from "../components/pages/ManageEnrollSubjectPage/DialogCertificate";
import MenuDashboard from "../components/pages/ManageEnrollSubjectPage/MenuDashboard";
import DashboardUser from "../components/pages/ManageEnrollSubjectPage/DashboardUser";
import DialogUnEnroll from "../components/pages/ManageEnrollSubjectPage/DialogUnEnroll";
import axios from "axios";

const URL_DASHBOARD = process.env.REACT_APP_DASHBOARD_API;

const getCertificateProgressValue = (progressEntry = {}) => {
  const progress = Number(progressEntry.progress) || 0;
  const zoomprogress = Number(progressEntry.zoomprogress) || 0;
  return progressEntry.certificateProgress ?? Math.max(progress, zoomprogress);
};

const ManageEnrollSubjectPage = () => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const { colorMode } = useColorMode();
  const params = useParams();
  const history = useHistory();
  const toast = useToast();
  const client = useApolloClient();

  const [dashboard, setDashboard] = useMultiState();
  const [isStudentPanelOpen, setIsStudentPanelOpen] = useState(false);
  const [processedProgressData, setProcessedProgressData] = useState(new Map());
  const [progressRefreshKey, setProgressRefreshKey] = useState(0);
  const [isProgressLoading, setIsProgressLoading] = useState(false);
  const [dashboardUserLoading, setDashboardUserLoading] = useState(false);
  const [contentQuestionsMap, setContentQuestionsMap] = useState(new Map());
  const [isContentQuestionsLoading, setIsContentQuestionsLoading] =
    useState(false);
  const [studentProcessedQuizAnswersMap, setStudentProcessedQuizAnswersMap] =
    useState(new Map());
  const [
    isStudentProcessedQuizAnswersLoading,
    setIsStudentProcessedQuizAnswersLoading,
  ] = useState(false);
  const [studentSurveyAnswersMap, setStudentSurveyAnswersMap] = useState(
    new Map()
  );
  const [isStudentSurveyAnswersLoading, setIsStudentSurveyAnswersLoading] =
    useState(false);

  const {
    isOpen: unEnrollSubject,
    onOpen: openUnEnrollSubject,
    onClose: closeUnEnrollSubject,
  } = useDisclosure();
  // const { isOpen: studentListDialog, onOpen: openStudentListDialog, onClose: closeStudentListDialog, } = useDisclosure()
  const {
    isOpen: certificateDialog,
    onOpen: openCertificateDialog,
    onClose: closeCertificateDialog,
  } = useDisclosure();

  const [setstudentofsubjectsRemoveMutation] = useMutation(
    studentofsubjectsRemoveMutation
  );
  const [setUpdateStudentOfSubject] = useMutation(updateStudentOfSubject);
  // const [getStudentProgress] = useLazyQuery(GetStudentProgress);
  // const [getContentQuestions, { loading: contentQuestionsLoading }] = useLazyQuery(GetContentQuestionConfigQuery);

  const [student, setStudent] = useState();
  const [progress, setProgress] = useState([]);
  const [loading, setLoading] = useState(false); // This is for the axios dashboard call

  const {
    data: SubjectData,
    loading: subjectQueryLoading,
    refetch: refetchSubject,
  } = useQuery(
    Subject,
    {
      // Renamed to avoid conflict
      variables: {
        _id: params?.subjectId,
      },
    },
    { fetchPolicy: "network-only" }
  );

  const { data: StudentEnroll, refetch: refetchEnroll } = useQuery(
    studentEnroll,
    {
      variables: {
        subject: params?.subjectId,
      },
    },
    { fetchPolicy: "network-only" }
  );

  const handleSubmitUnEnroll = async (e) => {
    e.preventDefault();
    try {
      const { data: responseUnEnroll } =
        await setstudentofsubjectsRemoveMutation({
          variables: {
            _id: student?._id,
          },
        });
      if (responseUnEnroll) {
        await toast({
          position: "top",
          title: "Success",
          description: `${t("ManageEnrollSubjectPage.toastSuccess")}`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        closeUnEnrollSubject();
        // closeStudentListDialog() // DialogListStudent is removed
        setIsStudentPanelOpen(false); // Close panel if open after unenroll
        refetchPage();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleUpdateCertificateStatus = async (e) => {
    e.preventDefault();
    // console.log("CERTIFICATE", student)
    try {
      const { data: approvedStatus } = await setUpdateStudentOfSubject({
        variables: {
          _id: student?._id,
          status: student?.status == "disapproved" ? "approved" : "disapproved",
        },
      });
      if (approvedStatus) {
        await toast({
          position: "top",
          title: "Success",
          description: `${t("ManageEnrollSubjectPage.update_certificate")}`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        closeCertificateDialog();
        refetchPage();
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user?.role === "STUDENT") {
      setTimeout(() => {
        history.push("/login");
      }, 100);
    }
  }, []);

  // Define event handlers for student selection and panel toggle
  const showMainDashboard = () => {
    setStudent(null);
    setIsStudentPanelOpen(false);
  };

  const viewStudentDetail = async (selectedStudentItem) => {
    if (
      !selectedStudentItem ||
      !selectedStudentItem.student ||
      !selectedStudentItem.student._id
    ) {
      console.error(
        "Invalid student item for viewing details:",
        selectedStudentItem
      );
      setStudent(null);
      setProgress([]);
      setIsStudentPanelOpen(false);
      setDashboardUserLoading(false); // Ensure loading is off if bailing early
      return;
    }

    setStudent(selectedStudentItem);
    setIsStudentPanelOpen(false);
    setDashboardUserLoading(true);
    setProgress([]); // Clear previous student's progress

    try {
      const rawProgressQueryResult = await client.query({
        query: GetStudentProgress,
        variables: { student: selectedStudentItem.student._id },
        fetchPolicy: "network-only",
      });

      console.log("Raw progress query result:", rawProgressQueryResult); // Log the raw result

      const { data: progressDataResult, error: progressError } =
        rawProgressQueryResult || {}; // Safeguard destructuring

      if (progressError) {
        // ... (rest of the error handling remains the same)
        console.error(
          "Error fetching progress for DashboardUser:",
          progressError
        );
        toast({
          title: t(
            "ManageEnrollSubjectPage.error_fetching_student_progress_title",
            "Error Fetching Student Progress"
          ),
          description:
            progressError.message ||
            t(
              "ManageEnrollSubjectPage.error_fetching_student_progress_desc",
              "Could not load progress for the selected student."
            ),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
        setProgress([]);
      } else if (progressDataResult && progressDataResult.progresss) {
        const allFetchedProgressItems = progressDataResult.progresss;
        const validFormattedProgress = [];
        const problematicProgressItems = [];

        allFetchedProgressItems.forEach((p) => {
          const contentId = p.content?._id;
          const progressValue = getCertificateProgressValue(p);

          if (contentId && progressValue !== undefined) {
            validFormattedProgress.push({
              _id: p._id,
              content: contentId,
              progress: progressValue,
              zoomprogress: p.zoomprogress || 0,
              original_item: p,
            });
          } else {
            problematicProgressItems.push({
              original_item: p,
              extracted_content_id: contentId,
              extracted_progress: progressValue,
            });
          }
        });

        if (problematicProgressItems.length > 0) {
          // console.warn("Problematic progress items found:", problematicProgressItems);
        }
        setProgress(validFormattedProgress);
      } else {
        // This case might be hit if rawProgressQueryResult is null/undefined leading to {}
        // or if data is null or progresss is null within data.
        console.warn(
          "No progress data or unexpected structure in progressDataResult for DashboardUser:",
          progressDataResult
        );
        setProgress([]); // No progress data found
      }
    } catch (e) {
      console.error("Exception during viewStudentDetail progress fetch:", e);
      toast({
        title: t(
          "ManageEnrollSubjectPage.error_unexpected_title",
          "Unexpected Error"
        ),
        description:
          e.message ||
          t(
            "ManageEnrollSubjectPage.error_fetching_student_progress_unexpected_desc",
            "An unexpected error occurred while fetching student progress."
          ),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      setProgress([]);
    } finally {
      setDashboardUserLoading(false);
    }
  };

  const toggleStudentPanelDisplay = () => {
    if (!isStudentPanelOpen && student) {
      // If panel is about to open and a student is selected
      setStudent(null); // Clear student view to show the list
    }
    setIsStudentPanelOpen(!isStudentPanelOpen);
  };

  // Corrected useEffect for axios
  useEffect(() => {
    const fetchDashboardDetailData = async () => {
      if (!student && !isStudentPanelOpen) {
        setLoading(true); // This is the 'loading' for DashboardDetail
        try {
          const response = await axios.post(
            `${URL_DASHBOARD}/${params?.subjectId}`
          );
          if (response.data) {
            setDashboard(response.data);
          }
        } catch (error) {
          console.log(error.response?.data?.error || error.message);
        } finally {
          setLoading(false);
        }
      } else {
        // If student is selected or panel is open, DashboardDetail is not shown,
        // so ensure its specific loading is false.
        setLoading(false);
      }
    };

    fetchDashboardDetailData();
  }, [
    SubjectData,
    student,
    isStudentPanelOpen,
    params?.subjectId,
    setDashboard,
    setLoading,
  ]); // Added student, isStudentPanelOpen, params?.subjectId, setDashboard, setLoading

  useEffect(() => {
    const fetchAllStudentProgress = async () => {
      if (
        isStudentPanelOpen &&
        StudentEnroll?.studentofsubjects &&
        StudentEnroll.studentofsubjects.length > 0
      ) {
        setIsProgressLoading(true);
        // Removed getStudentProgress availability check as client is always available

        const studentProgressPromises = StudentEnroll.studentofsubjects.map(
          (studentItem) => {
            if (studentItem.student?._id) {
              return client.query({
                query: GetStudentProgress,
                variables: { student: studentItem.student._id },
                fetchPolicy: "network-only",
              });
            }
            return Promise.resolve({ data: { progresss: [] } });
          }
        );

        try {
          const results = await Promise.all(studentProgressPromises);
          const newProgressData = new Map();

          results.forEach((result, index) => {
            const currentStudentItem = StudentEnroll.studentofsubjects[index];
            const studentId = currentStudentItem?.student?._id;
            if (!studentId) return;

            if (result && result.data && result.data.progresss) {
              const studentMapForTable =
                newProgressData.get(studentId) || new Map();
              const problematicItemsForThisStudent = [];
              result.data.progresss.forEach((progressEntry) => {
                const contentId = progressEntry.content?._id;
                const progressValue = getCertificateProgressValue(progressEntry);
                if (contentId && progressValue !== undefined) {
                  studentMapForTable.set(contentId, {
                    _id: progressEntry._id,
                    progress: Number(progressEntry.progress) || 0,
                    zoomprogress: Number(progressEntry.zoomprogress) || 0,
                    certificateProgress: progressValue,
                    original_item: progressEntry,
                  });
                } else {
                  problematicItemsForThisStudent.push({
                    original_item: progressEntry,
                    extracted_content_id: contentId,
                    extracted_progress: progressValue,
                  });
                }
              });

              if (problematicItemsForThisStudent.length > 0) {
                // console.warn(`Problematic progress items for student ${studentId}:`, problematicItemsForThisStudent);
              }

              if (studentMapForTable.size > 0) {
                newProgressData.set(studentId, studentMapForTable);
              }
            }
          });
          setProcessedProgressData(newProgressData);
        } catch (error) {
          console.error("Error fetching student progresses:", error);
          toast({
            title: t(
              "ManageEnrollSubjectPage.error_fetching_progress_title",
              "Error Fetching Progress"
            ),
            description: t(
              "ManageEnrollSubjectPage.error_fetching_progress_desc",
              "Could not load progress data for students."
            ),
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        } finally {
          setIsProgressLoading(false);
        }
      } else if (!isStudentPanelOpen) {
        // Optional: Clear previously loaded progress data when panel is closed
        // setProcessedProgressData(new Map());
        // setIsProgressLoading(false);
      }
    };

    fetchAllStudentProgress();
  }, [StudentEnroll, isStudentPanelOpen, client, toast, t, progressRefreshKey]);

  useEffect(() => {
    const fetchContentQuestions = async () => {
      const contents = SubjectData?.subject?.contents;
      if (contents?.length > 0) {
        setIsContentQuestionsLoading(true);
        const newContentQuestionsMap = new Map();
        try {
          for (const contentItem of contents) {
            if (!contentItem?._id) continue;

            if (contentItem.type === "survey") {
              console.log("Survey item found:", contentItem.name); // Added for debugging
              console.log(
                "Survey config for this item:",
                JSON.parse(JSON.stringify(contentItem.surveyconfig))
              ); // Added for debugging
              if (
                contentItem.surveyconfig?.surveyQuestions?.questions &&
                contentItem.surveyconfig.surveyQuestions.questions.length > 0
              ) {
                console.log(
                  "Populating contentQuestionsMap for survey:",
                  contentItem.name,
                  "with questions:",
                  contentItem.surveyconfig.surveyQuestions.questions
                ); // Added
                newContentQuestionsMap.set(
                  contentItem._id,
                  contentItem.surveyconfig.surveyQuestions.questions
                );
              } else {
                console.log(
                  "Survey item has no questions in surveyconfig or questions array is empty:",
                  contentItem.name
                ); // Added
                newContentQuestionsMap.set(contentItem._id, []);
              }
            } else if (contentItem.type === "quiz") {
              // Assuming other types might also use questionconfig
              // For quizzes (and potentially other types), fetch questionconfig
              const { data: questionConfigData, error } = await client.query({
                query: GetContentQuestionConfigQuery,
                variables: { _id: contentItem._id },
                fetchPolicy: "network-only",
              });

              if (error) {
                console.warn(
                  `Error fetching question config for content ${contentItem.name} (ID: ${contentItem._id}):`,
                  error
                );
                newContentQuestionsMap.set(contentItem._id, null); // Indicate error
                continue;
              }

              if (questionConfigData?.content?.questionconfig?.questionList) {
                newContentQuestionsMap.set(
                  contentItem._id,
                  questionConfigData.content.questionconfig.questionList
                );
              } else {
                newContentQuestionsMap.set(contentItem._id, []); // No quiz questions defined or structure mismatch
              }
            } else {
              // For other content types, assume no exportable questions for now, or handle if needed
              newContentQuestionsMap.set(contentItem._id, []);
            }
          }
          setContentQuestionsMap(newContentQuestionsMap);
        } catch (e) {
          console.error("Error processing content question configurations:", e);
          toast({
            title: t(
              "ManageEnrollSubjectPage.error_fetching_questions_title",
              "Error Fetching Questions"
            ),
            description: t(
              "ManageEnrollSubjectPage.error_fetching_questions_desc",
              "Could not load question configurations for content items."
            ),
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        } finally {
          setIsContentQuestionsLoading(false);
        }
      } else {
        // Clear map if no contents
        setContentQuestionsMap(new Map());
      }
    };

    fetchContentQuestions();
  }, [SubjectData, client, toast, t]);

  useEffect(() => {
    const fetchStudentProcessedQuizAnswers = async () => {
      const students = StudentEnroll?.studentofsubjects;
      const contents = SubjectData?.subject?.contents;

      if (students?.length > 0 && contents?.length > 0) {
        setIsStudentProcessedQuizAnswersLoading(true); // Use new loading state
        const newStudentProcessedAnswersMap = new Map();

        for (const studentItem of students) {
          const studentId = studentItem?.student?._id;
          if (!studentId) continue;

          const processedAnswersForThisStudent = new Map();
          for (const contentItem of contents) {
            if (contentItem?.type === "quiz" && contentItem?._id) {
              try {
                const { data: scoresData, error } = await client.query({
                  query: GetScoresQuery, // Use the new query for scores
                  variables: { student: studentId, id: contentItem._id }, // 'id' is the contentId for this query
                  fetchPolicy: "network-only",
                });

                if (error) {
                  console.warn(
                    `Error fetching scores for student ${studentId}, content ${contentItem._id}:`,
                    error
                  );
                  processedAnswersForThisStudent.set(contentItem._id, null);
                } else if (
                  scoresData?.scores &&
                  scoresData.scores.length > 0 &&
                  scoresData.scores[0]?.quiz &&
                  scoresData.scores[0].quiz.length > 0 &&
                  scoresData.scores[0].quiz[0]?.answer
                ) {
                  // Path based on QuestionPage.js: scoreAddData?.scores[0]?.quiz[0]?.answer
                  processedAnswersForThisStudent.set(
                    contentItem._id,
                    scoresData.scores[0].quiz[0].answer
                  );
                } else {
                  // No scores found, or structure doesn't match
                  processedAnswersForThisStudent.set(contentItem._id, null);
                  // console.log(`No processed answers found for student ${studentId}, content ${contentItem.name} (${contentItem._id}). Response:`, scoresData);
                }
              } catch (e) {
                console.error(
                  `Exception fetching scores for student ${studentId}, content ${contentItem._id}:`,
                  e
                );
                processedAnswersForThisStudent.set(contentItem._id, null);
              }
            }
          }
          if (processedAnswersForThisStudent.size > 0) {
            newStudentProcessedAnswersMap.set(
              studentId,
              processedAnswersForThisStudent
            );
          }
        }
        setStudentProcessedQuizAnswersMap(newStudentProcessedAnswersMap); // Set new state
        setIsStudentProcessedQuizAnswersLoading(false); // Use new loading state
      } else {
        setStudentProcessedQuizAnswersMap(new Map());
        setIsStudentProcessedQuizAnswersLoading(false);
      }
    };

    fetchStudentProcessedQuizAnswers();
  }, [StudentEnroll, SubjectData, client, progressRefreshKey]);

  useEffect(() => {
    const fetchStudentSurveyAnswers = async () => {
      const students = StudentEnroll?.studentofsubjects;
      const contents = SubjectData?.subject?.contents;

      if (students?.length > 0 && contents?.length > 0) {
        setIsStudentSurveyAnswersLoading(true);
        const newStudentSurveyAnswersMap = new Map();

        for (const studentItem of students) {
          const studentId = studentItem?.student?._id;
          if (!studentId) continue;

          const surveyAnswersForThisStudent = new Map();
          for (const contentItem of contents) {
            if (contentItem?.type === "survey" && contentItem?._id) {
              try {
                const { data: surveySubmissionData, error } =
                  await client.query({
                    query: GetStudentSurveyAnswersQuery, // Use the corrected import
                    variables: { student: studentId, content: contentItem._id },
                    fetchPolicy: "network-only",
                  });

                if (error) {
                  console.warn(
                    `Error fetching survey answers for student ${studentId}, content ${contentItem._id}:`,
                    error
                  );
                  surveyAnswersForThisStudent.set(contentItem._id, null);
                } else if (surveySubmissionData?.survey?.surveyAnswers) {
                  surveyAnswersForThisStudent.set(
                    contentItem._id,
                    surveySubmissionData.survey.surveyAnswers
                  );
                } else {
                  surveyAnswersForThisStudent.set(contentItem._id, null); // No submission or empty answers
                }
              } catch (e) {
                console.error(
                  `Exception fetching survey answers for student ${studentId}, content ${contentItem._id}:`,
                  e
                );
                surveyAnswersForThisStudent.set(contentItem._id, null);
              }
            }
          }
          if (surveyAnswersForThisStudent.size > 0) {
            newStudentSurveyAnswersMap.set(
              studentId,
              surveyAnswersForThisStudent
            );
          }
        }
        setStudentSurveyAnswersMap(newStudentSurveyAnswersMap);
        setIsStudentSurveyAnswersLoading(false);
      } else {
        setStudentSurveyAnswersMap(new Map());
        setIsStudentSurveyAnswersLoading(false);
      }
    };

    fetchStudentSurveyAnswers();
  }, [StudentEnroll, SubjectData, client, GetStudentSurveyAnswersQuery, progressRefreshKey]); // Added GetStudentSurveyAnswersQuery to dependency array

  const refetchPage = () => {
    // refetchProgress()
    refetchSubject({
      _id: params?.subjectId,
    });
    refetchEnroll({
      subject: params?.subjectId,
    });
  };

  return (
    <Fragment>
      <Box w="100%" h="auto" sx={{ overflowX: ["auto", "auto", "none"] }}>
        <Flex
          minHeight={"90vh"}
          templateRows="repeat(2, 1fr)"
          templateColumns="repeat(12, 1fr)"
          gap={0}
          direction={["column", "column", "row", "row"]}
        >
          <MenuDashboard
            setStudent={showMainDashboard} // For "Dashboard" button
            toggleStudentPanel={toggleStudentPanelDisplay} // For "Student List" button
            SubjectData={SubjectData}
            subjectId={params?.subjectId}
          />
          <Box
            flex="1"
            px={["2", "5", "5", "10"]}
            bg={colorMode === "light" ? "gray.100" : "brand.700"}
            sx={{ overflowX: ["auto", "auto", "none"] }}
          >
            {isStudentPanelOpen ? (
              <StudentListPanel
                studentList={StudentEnroll?.studentofsubjects}
                contentList={SubjectData?.subject?.contents || []}
                progressData={processedProgressData}
                contentQuestionsMap={contentQuestionsMap}
                studentProcessedQuizAnswersMap={studentProcessedQuizAnswersMap}
                studentSurveyAnswersMap={studentSurveyAnswersMap} // Pass new map for surveys
                isLoading={
                  isProgressLoading ||
                  subjectQueryLoading ||
                  isContentQuestionsLoading ||
                  isStudentProcessedQuizAnswersLoading ||
                  isStudentSurveyAnswersLoading
                } // Include all loading states
                setStudent={viewStudentDetail}
                currentSubjectId={params?.subjectId}
                onZoomProgressImported={() => setProgressRefreshKey((value) => value + 1)}
                onProgressCleared={() => setProgressRefreshKey((value) => value + 1)}
                onStudentsImported={refetchPage}
              />
            ) : student ? (
              <DashboardUser
                loading={dashboardUserLoading}
                student={student}
                SubjectData={SubjectData}
                progressList={progress}
                openCertificateDialog={openCertificateDialog}
              />
            ) : (
              <DashboardDetail
                loading={loading}
                total={dashboard?.dashboard_total}
                pass={dashboard?.dashboard_pass}
                notpass={dashboard?.dashboard_notpass}
                certificate={dashboard?.dashboard_certificate}
                credit={dashboard?.dashboard_credit}
                dashboardContent={dashboard?.content}
              />
            )}
          </Box>
        </Flex>
      </Box>

      {/* <DialogListStudent
                setLoading={setLoading}
                contents={SubjectData?.subject?.contents}
                setProgress={setProgress}
                setStudent={setStudent}
                studentList={StudentEnroll?.studentofsubjects}
                studentListDialog={studentListDialog}
                closeStudentListDialog={closeStudentListDialog}
                openUnEnrollSubject={openUnEnrollSubject} /> */}

      <DialogCertificate
        student={student}
        handleUpdateCertificateStatus={handleUpdateCertificateStatus}
        certificateDialog={certificateDialog}
        closeCertificateDialog={closeCertificateDialog}
      />

      <DialogUnEnroll
        student={student}
        unEnrollSubject={unEnrollSubject}
        closeUnEnrollSubject={closeUnEnrollSubject}
        handleSubmitUnEnroll={handleSubmitUnEnroll}
      />
    </Fragment>
  );
};

export default ManageEnrollSubjectPage;
